module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-511.890cc7b.woff2";